import React from 'react';
import { InfoText } from '../info-text';
import { useParams } from 'react-router-dom';

import { DownloadableReport } from './downloadable/report';
import { DownloadableResponses } from './downloadable/responses';
import { useGetEventReportDetail } from '../../../hooks/services/use-reports';

export const FeedbackActivityReport: React.FC<{ eventName: string }> = ({
  eventName
}) => {
  const { eventId, detailId } = useParams();

  const { data } = useGetEventReportDetail({
    type: 'feedbacks',
    playlistId: detailId,
    eventId
  });

  return (
    <div>
      <span
        style={{
          fontWeight: 600
        }}>
        Feedback
      </span>
      <div
        style={{
          border: '1px solid #CFD4D9',
          borderRadius: '4px',
          padding: '22px 27px',
          display: 'flex',
          flexDirection: 'column',
          gap: '17px'
        }}>
        <div
          className={'d-flex'}
          style={{
            gap: '92px'
          }}>
          <InfoText heading={'Name'} text={data?.name ?? ''} />
        </div>
        <div
          className={'d-flex'}
          style={{
            gap: '92px'
          }}>
          <InfoText heading={'Contact'} text={data?.contact ?? ''} />
        </div>

        <div
          style={{
            display: 'flex',
            gap: '24px'
          }}>
          <DownloadableReport fileName={eventName} />
          <DownloadableResponses
            amount={data?.responses ?? 0}
            fileName={eventName}
          />
        </div>
      </div>
    </div>
  );
};
